import { render, staticRenderFns } from "./user-popover.vue?vue&type=template&id=3071b1fe&"
import script from "./user-popover.vue?vue&type=script&lang=js&"
export * from "./user-popover.vue?vue&type=script&lang=js&"
import style0 from "./user-popover.vue?vue&type=style&index=0&id=3071b1fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports